var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurringSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6237 2C15.4486 2 16.2397 2.32924 16.823 2.91529C17.4063 3.50134 17.734 4.2962 17.734 5.125V7.32125C16.5093 6.30337 14.969 5.74757 13.3796 5.75L16.4899 5.75V5.125C16.4899 4.62772 16.2932 4.15081 15.9433 3.79918C15.5933 3.44754 15.1186 3.25 14.6237 3.25L5.91495 3.25C5.42002 3.25 4.94535 3.44754 4.59538 3.79917C4.24541 4.15081 4.04879 4.62772 4.04879 5.125V5.75L13.3796 5.75C11.9153 5.75 10.558 6.2125 9.44448 7L4.04879 7L4.04879 13.875C4.04879 14.3723 4.24541 14.8492 4.59538 15.2008C4.94535 15.5525 5.42002 15.75 5.91495 15.75H7.28347C7.51114 16.1975 7.78609 16.6163 8.10085 17H5.91495C5.09006 17 4.29895 16.6708 3.71566 16.0847C3.13238 15.4987 2.80469 14.7038 2.80469 13.875L2.80469 5.125C2.80469 4.2962 3.13238 3.50134 3.71566 2.91529C4.29895 2.32924 5.09006 2 5.91495 2L14.6237 2Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9781 12.625C18.9781 13.3637 18.8333 14.0951 18.5519 14.7776C18.2706 15.4601 17.8582 16.0801 17.3383 16.6025C16.8184 17.1248 16.2013 17.5391 15.522 17.8218C14.8428 18.1045 14.1148 18.25 13.3796 18.25C12.6444 18.25 11.9164 18.1045 11.2371 17.8218C10.5579 17.5391 9.94074 17.1248 9.42087 16.6025C8.901 16.0801 8.48862 15.4601 8.20727 14.7776C7.92592 14.0951 7.78111 13.3637 7.78111 12.625C7.78111 11.1332 8.37095 9.70242 9.42087 8.64752C10.4708 7.59263 11.8948 7 13.3796 7C14.8644 7 16.2884 7.59263 17.3383 8.64752C18.3882 9.70242 18.9781 11.1332 18.9781 12.625Z",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3047 11.0001C11.8047 8.3336 14.8047 8.33364 16.3047 11.0001M16.3047 11.0001V9.5M16.3047 11.0001L15.3047 11",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3047 14.0001C14.8047 16.6666 11.8047 16.6666 10.3047 14.0001M10.3047 14.0001V15.5002M10.3047 14.0001L11.3047 14.0002",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringSchedule);
export default __webpack_public_path__ + "static/media/recurring-schedule.cdec8a584554198220f5ce7a917eb49c.svg";
export { ForwardRef as ReactComponent };